// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var DunningDetailsController = function ($scope, $routeParams, Dunning, DunningDownload) {
    $scope.dunningDetails = Dunning.get({ id: $routeParams.dunningId });

    $scope.download = function () {
        var downloadInfo = new DunningDownload();
        downloadInfo.$save({ id: $routeParams.dunningId }, function () {
            window.location = downloadInfo.Url;
        });
    };
}
DunningDetailsController.$inject = ['$scope', '$routeParams', 'Dunning', 'DunningDownload'];
